/* eslint-disable @typescript-eslint/no-explicit-any */
/**
     * @desc 小程序用户信息授权
返回小程序用户信息授权结果
     */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  miniProgramAuth: oauth2.MiniAppAuthorizationDTO,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: oauth2.OAuth2AccessTokenDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/oauth2/theater/ma/oauth`,
    data: miniProgramAuth,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
